module.exports = __webpack_public_path__ + "static/media/1.dfc6d310.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/1.jpg
// module id = 341
// module chunks = 2